/* eslint-disable react-hooks/exhaustive-deps,no-console */
import * as React from "react";
import { useContext } from "react";
import RouteNumberArea from "./RouteNumberArea/RouteNumberArea";
import { StopDataCard } from "./StopData/StopDataCard";
import { RouteDetails } from "./RouteDetails/RouteDetails";
import InboundPipeline from "./InboundPipeline/InboundPipeline";
import ReturnPipeline from "./ReturnPipeline/ReturnPipeline";
import { EditProjectContext } from "../../EditProjectContext";
import { FtlRouteViewModel } from "../../../ViewModel/FtlRouteViewModel";
import { getListOfOdcsFromRoutingTable } from "./GetListOfOdcsFromRoutingTable";
import PlantDocksForLtlPipelineGrid from "./PlantDock/PlantDocksForLtlPipelineGrid";
import { RouteType } from "../../../ViewModel/RouteType";
import { UploadVolumeData } from "./InboundPipeline/UploadVolumeData";
import ODCNetworkForLTLReturnRouting from "./OdcRelation/ODCNetworkForLTLReturnRouting";
import { setSpdrsOnThisRoute } from "../../SetSpdrsOnThisRoute";
import { setPdsrsOnThisRoute } from "../../SetPdsrsOnThisRoute";
import { ReadOnlyProps } from "../../ReadOnlyProps";

type Props = {
  ftlRoute: FtlRouteViewModel;
};

export const FtlRouteCard = ({ ftlRoute, isReadOnly }: Props & ReadOnlyProps) => {
  const { project, setProject } = useContext(EditProjectContext);

  const spdrsOnThisRoute = ftlRoute.SpdrsOnThisRoute ?? [];
  const pdsrsOnThisRoute = ftlRoute.PdsrsOnThisRoute ?? [];

  const odcGsdbsOnRoute = getListOfOdcsFromRoutingTable(ftlRoute.RoutingTable);
  const volumeDataUpload = (
    <UploadVolumeData
      spdrsOnThisRoute={spdrsOnThisRoute}
      setSpdrsOnThisRoute={(items) =>
        setSpdrsOnThisRoute(ftlRoute.RouteId, items || [], {
          project,
          setProject,
        })
      }
      pdsrsOnThisRoute={pdsrsOnThisRoute}
      setPdsrsOnThisRoute={(items) =>
        setPdsrsOnThisRoute(ftlRoute.RouteId, items || [], {
          project,
          setProject,
        })
      }
      isReadonly={isReadOnly}
    />
  );

  return (
    <>
      <RouteNumberArea route={ftlRoute} isReadOnly={isReadOnly} />

      <StopDataCard
        routingTable={ftlRoute.RoutingTable}
        routeId={ftlRoute.RouteId}
        isReadOnly={isReadOnly}
      />

      <RouteDetails route={ftlRoute} isReadOnly={isReadOnly} />

      <InboundPipeline
        spdrsOnThisRoute={spdrsOnThisRoute}
        setSpdrsOnThisRoute={(items) =>
          setSpdrsOnThisRoute(ftlRoute.RouteId, items || [], {
            project,
            setProject,
          })
        }
        ftlRouteNumber={ftlRoute.RouteNumber}
        odcGsdbsForColumns={ftlRoute.RouteType !== "FTL" ? odcGsdbsOnRoute : []}
        volumeDataUpload={volumeDataUpload}
        isReadOnly={isReadOnly}
      />
      <ReturnPipeline
        pdsrsOnThisRoute={pdsrsOnThisRoute}
        setPdsrsOnThisRoute={(items) =>
          setPdsrsOnThisRoute(ftlRoute.RouteId, items || [], {
            project,
            setProject,
          })
        }
        ftlRouteNumber={ftlRoute.RouteNumber}
        odcGsdbsForColumns={ftlRoute.RouteType !== "FTL" ? odcGsdbsOnRoute : []}
        volumeDataUpload={volumeDataUpload}
        isReadOnly={isReadOnly}
      />
      <div>
        {(ftlRoute.RouteType === RouteType.Trunk || ftlRoute.RouteType === RouteType["Top-Up"]) && (
          <PlantDocksForLtlPipelineGrid
            docks={ftlRoute.Docks ?? []}
            ftlRouteId={ftlRoute.RouteId}
          />
        )}
      </div>
      <div>
        {(ftlRoute.RouteType === RouteType.Trunk || ftlRoute.RouteType === RouteType["Top-Up"]) && (
          <ODCNetworkForLTLReturnRouting odcs={ftlRoute.Odcs ?? []} ftlRouteId={ftlRoute.RouteId} />
        )}
      </div>
    </>
  );
};
